import styled from "styled-components";
import { EIconSize } from "../interface/Icon";

export const SvgIconRoot = styled("svg")<{ $size?: EIconSize }>(
  ({ color, $size = 24 }) => ({
    userSelect: "none",
    width: `${$size}px`,
    minWidth: `${$size}px`,
    height: `${$size}px`,
    display: "inline-block",
    "&:not(.svg-icon-static) path": {
      fill: color || "currentColor",
    },
    "&.svg-icon-static": {
      "& > *": {
        fill: "transparent",
      },
    },
  })
);
